import { SelectionActionTypes, ADD_SELECTION, REMOVE_SELECTION, CLEAR_SELECTION } from './types'

export function addSelection(title: string, file: string, language: string): SelectionActionTypes {
  return {
    type: ADD_SELECTION,
    item: {
      title,
      file,
      language
    }
  }
}

export function removeSelection(title: string): SelectionActionTypes {
  return {
    type: REMOVE_SELECTION,
    title
  }
}
export function clearSelection(): SelectionActionTypes {
  return {
    type: CLEAR_SELECTION
  }
}
